/* eslint-disable no-param-reassign */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { get } from 'lodash';
import moment from 'utils/moment';
import { handleCalculation } from '../../../modules/forms/utils/helpers';
import {
  fetchDataSoureValues
} from '../../../modules/inspections/redux/actions';
import Clickable from '../../../components/clickable/Clickable';
import styles from '../fields.module.scss';

class NumberField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rawSSN: this.props.answer
    };
    const { isRequired, updateFieldErrors, answer, default_number, fieldId } = this.props;

    if (isRequired && (answer === '' || answer === undefined)) {
      updateFieldErrors(['pulpoforms.errors.not_blank']);
    }
    if (default_number && fieldId && !answer) {
      this.handleAnswerChanged(default_number, fieldId);
    }
  }

  componentDidMount() {
    const { answer, updateFieldErrors, fieldId, fromMultiGrid, multiFields, fields } = this.props;
    if (answer) {
      const field_type = (fromMultiGrid && multiFields?.[fieldId])
        ? multiFields?.[fieldId]?.inputType
        : (Array.isArray(fields) ? fields.find(obj => obj.id === fieldId) : fields?.[fieldId])?.validators?.[0];
      if (field_type?.type === 'min_max') {
        const updatedErrors = this.checkMinMaxError(field_type, answer);
        updateFieldErrors(updatedErrors);
      }
    }
  }

  componentDidUpdate(prevProps) {
    const {
      fieldId, settings, dataSourceValues, dataSourceCountAction,
      handleValueChange, handleFieldErrorChanged, updateFieldErrors
    } = this.props;
    if (settings?.form_count
      && prevProps.dataSourceCountAction?.[fieldId]?.loading === true && dataSourceCountAction?.[fieldId]?.loading === false
    ) {
      let result = dataSourceValues?.length;
      if (settings?.form_sum_field?.id) {
        let sum = 0;
        dataSourceValues.forEach((val) => {
          if (val?.data?.[settings?.form_sum_field?.id] && Number(val?.data?.[settings?.form_sum_field?.id]) > 0) {
            sum += Number(val?.data?.[settings?.form_sum_field?.id]);
          }
        });
        result = sum;
      }
      handleValueChange(result, fieldId);
      if (settings?.enable_restriction && result && Number(result) > 0) {
        handleFieldErrorChanged(fieldId, true);
        updateFieldErrors([
          'pulpoforms.errors.not_blank'
        ]);
      } else {
        handleFieldErrorChanged(fieldId, false);
        updateFieldErrors([]);
      }
    }
  }

  format = (v) => {
    v = v.slice(0, 11).replace(/-/g, '');
    if (v.length <= 3) {
      return v;
    }
    if (v.length > 3 && v.length <= 5) {
      return `${v.slice(0, 3)}-${v.slice(3)}`;
    }
    if (v.length > 5) {
      return `${v.slice(0, 3)}-${v.slice(3, 5)}-${v.slice(5)}`;
    } return null;
  };

  mask = (v) => {
    const masked = v.slice(0, 7).replace(/[0-9]/g, 'X');
    const final = masked + v.slice(7);
    return final;
  };

  handleCalValues = async (e) => {
    const { fields, answers, fromMultiGrid, allFields, handleValueChange, multiFieldId, formTabFeilds, formEntryFields,
      formApprovalSteps, exposeFieldsList, exposeFieldsData, multiFields, fieldId
    } = this.props;

    const currentInputValue = e?.target?.value;
    const freshAnswers = (currentInputValue !== undefined && fieldId)
      ? { ...answers, [fieldId]: currentInputValue }
      : answers;

    let result;
    if (fromMultiGrid) {
      result = await handleCalculation(fields, freshAnswers, fromMultiGrid, allFields,
        multiFieldId, undefined, undefined, undefined, e?.target?.name.split('-')[3]);
    } else if (formApprovalSteps) {
      result = await handleCalculation(formTabFeilds, freshAnswers, undefined, undefined, undefined,
         formApprovalSteps, exposeFieldsList, exposeFieldsData);
    } else {
      result = await handleCalculation(formEntryFields || formTabFeilds, freshAnswers);
    }
    await result.reduce(async (promise, val) => {
      await promise;

      if (!val?.id) return;

      // Find field schema
      let fieldSchema;
      if (fromMultiGrid) {
        fieldSchema = Array.isArray(fields) ? fields.find(f => f.id === val.id) : fields?.[val.id];
      } else if (formApprovalSteps) {
        fieldSchema = Array.isArray(formTabFeilds) ? formTabFeilds.find(f => f.id === val.id) : formTabFeilds?.[val.id];
      } else {
        const entryFields = formEntryFields || formTabFeilds;
        fieldSchema = Array.isArray(entryFields) ? entryFields.find(f => f.id === val.id) : entryFields?.[val.id];
      }
      const decimalConfig = (fromMultiGrid && multiFields?.[val.id])
        ? multiFields?.[val.id]?.decimal_point
        : fieldSchema?.settings?.validations?.decimal_point;

      const allowedDecimals = typeof decimalConfig?.name === 'number'
        ? decimalConfig.name
        : null;

      let finalValue = val?.value;

      if (
        allowedDecimals !== null
        && finalValue !== ''
        && finalValue !== undefined
        && !Number.isNaN(Number(finalValue))
      ) {
        const valueStr = String(finalValue);

        if (valueStr.includes('.')) {
          const [intPart, decimalPart] = valueStr.split('.');

          finalValue = decimalPart !== undefined
            ? `${intPart}.${decimalPart.slice(0, allowedDecimals)}`
            : intPart;
        }
      }
      handleValueChange(finalValue, val.id);
    }, Promise.resolve());
  }

  handleSearch = () => {
    const { actionDataSource, settings, answers, fieldId, formEntryDetails } = this.props;
    const filters = {};
    let startDate = '';
    let endDate = '';
    if (settings?.count_map_fields && Object.keys(settings?.count_map_fields)?.length > 0) {
      Object.keys(settings.count_map_fields).forEach((cF) => {
        if (settings.count_map_fields?.[cF]?.type === 'date') {
          filters[`data__${cF}__in`] = [
            answers?.[settings.count_map_fields?.[cF]?.id],
            moment(answers?.[settings.count_map_fields?.[cF]?.id]).utc().format()
          ];
        } else {
          filters[`data__${cF}`] = answers?.[settings.count_map_fields?.[cF]?.id];
        }
      });
    }
    if (settings?.form_count_date?.value?.length > 0 && settings?.form_count_days && Number(settings?.form_count_days) > 0) {
      if (answers?.[settings?.form_count_date?.value] || formEntryDetails?.[settings?.form_count_date?.value]) {
        endDate = new Date();
        if (settings?.form_count_date?.value === 'form_date') {
          endDate = new Date(formEntryDetails?.[settings?.form_count_date?.value]);
          startDate = new Date(formEntryDetails?.[settings?.form_count_date?.value]);
        } else {
          endDate = new Date(answers?.[settings?.form_count_date?.value]);
          startDate = new Date(answers?.[settings?.form_count_date?.value]);
        }
        if ((answers?.[settings?.form_count_date?.value]
          || formEntryDetails?.[settings?.form_count_date?.value]
        ) && settings?.form_count_days && Number(settings?.form_count_days) > 0) {
          startDate.setDate(new Date(endDate).getDate() - Number(settings?.form_count_days));
          startDate = new Date(startDate);
          endDate = new Date(endDate);
          actionDataSource(
            'get',
            undefined,
            '/form/get_form_data/',
            fieldId,
            {
              form_key: settings?.count_form?.key,
              field_id: settings.form_count_fields?.[0]?.id,
              id: settings?.count_form?.id,
              additional_filters: {
                'filters': filters,
                'start_date': startDate,
                'end_date': endDate,
                'date_field': settings?.form_count_date?.value
              }
            }
          );
        }
      }
    } else {
      actionDataSource(
        'get',
        undefined,
        '/form/get_form_data/',
        fieldId,
        {
          form_key: settings?.count_form?.key,
          field_id: settings.form_count_fields?.[0]?.id,
          id: settings?.count_form?.id,
          additional_filters: { 'filters': filters }
        }
      );
    }
  }

  handleAnswerChanged(value, fieldId) {
    const {
      handleValueChange, handleFieldErrorChanged, isRequired, updateFieldErrors, fields, fromMultiGrid,
      multiFields, settings
    } = this.props;
    const field_type = (fromMultiGrid && multiFields?.[fieldId])
      ? multiFields?.[fieldId]?.inputType
      : (Array.isArray(fields) ? fields.find(obj => obj.id === fieldId) : fields?.[fieldId])?.validators?.[0];
    const max_min = field_type || {};
    const decimalConfig = (fromMultiGrid && multiFields?.[fieldId])
      ? multiFields?.[fieldId]?.decimal_point
      : settings?.validations?.decimal_point;

    const allowedDecimals = typeof decimalConfig?.name === 'number'
      ? decimalConfig.name
      : null;

    let finalValue = value;

    if (fieldId === 'social_security_number') {
      if (value.replace(/-/g, '').length < this.state.rawSSN.length) {
        const last = this.state.rawSSN.length - 1;
        this.setState(prev => ({
          rawSSN: prev.rawSSN.slice(0, last)
        }));
        return finalValue;
      }
      let numValue = value.replace(/\D/g, '');
      let newSSN = '';
      if (this.state.rawSSN.length > 5) {
        newSSN = this.state.rawSSN.slice(0, 5) + numValue;
      } else {
        newSSN = this.state.rawSSN + numValue;
      }
      if (newSSN.length > 9) {
        return finalValue;
      }
      this.setState({
        rawSSN: newSSN
      });
      finalValue = newSSN;
      handleValueChange(newSSN, fieldId);
    }
    if (fieldId !== 'social_security_number') {
      if (
        allowedDecimals !== null
        && finalValue !== ''
        && finalValue !== undefined
        && !Number.isNaN(Number(finalValue))
      ) {
        const valueStr = String(finalValue);

        if (valueStr.includes('.')) {
          const [intPart, decimalPart] = valueStr.split('.');

          finalValue = decimalPart !== undefined
            ? `${intPart}.${decimalPart.slice(0, allowedDecimals)}`
            : intPart;
        }
      }
      handleValueChange(finalValue, fieldId);
    }
    let updatedErrors = [];

    if (value === '' || value === undefined) {
      handleFieldErrorChanged(fieldId, isRequired);
      updatedErrors = [
        ...updatedErrors,
        'pulpoforms.errors.not_blank'
      ];
    } else if (max_min?.type === 'min_max') {
      const length = value?.length ?? 0;
      const min = max_min?.minValue && +max_min?.minValue;
      const max = max_min?.maxValue && +max_min?.maxValue;

      if (min && length < min) {
        updatedErrors = [
          ...updatedErrors,
          {
            id: 'pulpoforms.errors.limit.minlength',
            values: { count: min }
          }
        ];
        handleFieldErrorChanged(fieldId, true);
      } else if (max && length > max) {
        updatedErrors = [
          ...updatedErrors,
          {
            id: 'pulpoforms.errors.limit.maxlength',
            values: { count: max }
          }
        ];
        handleFieldErrorChanged(fieldId, true);
      } else {
        handleFieldErrorChanged(fieldId, false);
      }
    } else {
      handleFieldErrorChanged(fieldId, false);
    }
    updateFieldErrors(updatedErrors);
    return finalValue;
  }

  render() {
    const { fieldId, answer, placeHolderValue, min, keypress,
      disabled=false, settings, validators
    } = this.props;
    return (
      <>
      {fieldId !== 'social_security_number' && (
        <input
          type="number"
          name={`number-field-${fieldId}`}
          defaultValue={answer}
          className="pulpo-numberfield"
          onChange={(e) => {
            const type = validators?.[0]?.type;
            let val = e.target.value;

            const acceptValue = (v) => {
              const storedValue = this.handleAnswerChanged(v, fieldId);
              // Trigger calculation immediately as the user types
              this.handleCalValues({ target: { value: storedValue !== undefined ? storedValue : v, name: e.target.name } });
            };

            if (type === 'positiveInput') {
              // only positive numbers & zero
              if (val === '') {
                acceptValue('');
              } else if (/^\d*\.?\d*$/.test(val)) {
                acceptValue(val);
              }
            } else if (type === 'negativeInput') {
              // only negative numbers & zero
              if (val === '') {
                acceptValue('');
              } else if (/^-?\d*\.?\d*$/.test(val)) {
                // enforce <= 0
                if (parseFloat(val) <= 0) {
                  acceptValue(val);
                }
              }
            } else {
              acceptValue(val);
            }
          }}
          onBlur={this.handleCalValues}
          placeholder={placeHolderValue}
          min={min}
          onKeyPress={(e) => {
            const type = validators?.[0]?.type;

            if (type === 'positiveInput') {
              // block "-" and scientific notation
              if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                e.preventDefault();
              }
            }

            if (type === 'negativeInput') {
              // block scientific notation but allow "-"
              if (e.key === 'e' || e.key === 'E') {
                e.preventDefault();
              }
            }

            if (keypress) keypress(e);
          }}
          disabled={settings?.form_count || disabled}
          value={answer}
        />
      )}
      {settings?.form_count && (
        <div className={styles.formCount} id={fieldId}>
          {answer !== undefined && (
            <p>Count: {answer}</p>
          )}
          <Clickable
            className={styles.detailsLink}
            onClick={this.handleSearch}
          >
            <FormattedMessage
              id="topbar.search"
              defaultMessage="Search"
              tagName="p"
            />
          </Clickable>
        </div>
      )}
      {fieldId === 'social_security_number' && (
        <input
          type="name"
          name={`number-field-${fieldId}`}
          value={this.mask(this.format(this.state.rawSSN))}
          defaultValue={answer}
          onChange={e => this.handleAnswerChanged(e.target.value, fieldId)}
          autoComplete="off"
        />
      )}
      </>
    );
  }
}


NumberField.propTypes = {
  handleValueChange: PropTypes.func.isRequired,
  fieldId: PropTypes.string.isRequired,
  answer: PropTypes.string,
  isRequired: PropTypes.bool.isRequired,
  handleFieldErrorChanged: PropTypes.func.isRequired,
  updateFieldErrors: PropTypes.func.isRequired
};

NumberField.defaultProps = {
  answer: ''
};

const mapStateToProps = (state, props) => ({
  dataSourceValues:
    get(
      state,
      `inspection.dataSourceValues[${get(props, 'fieldId') || props.fieldId}]`
    ) || {},
  dataSourceCountAction: state.inspection.dataSourceCountAction
});

const mapDispatchToProps = dispatch => ({
  actionDataSource: (methodName, data, sourceURL, id, filters) => {
    dispatch(fetchDataSoureValues(methodName, data, sourceURL, id, filters));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(NumberField);
